import { useSessionTenantOrigin } from "../../hooks/useSessionTenantOrigin";
import { Box } from "../Box";
import { CodeBlock } from "../CodeBlock";
import { Link } from "../Link";
import { Text } from "../Text";
import { CopyableValue } from "./CopyableValue";
import {
  PanelCard,
  PanelContentBox,
  PanelHeader,
  PanelShell,
} from "./SettingsPanel";

const MCP_DOCS_URL =
  "https://docs.3b.tines.com/en/articles/16050745-connect-an-ai-client-to-tines-3b-with-mcp";

export function McpSettings() {
  const tenantOrigin = useSessionTenantOrigin();
  const url = `${tenantOrigin}/mcp`;
  return (
    <PanelShell>
      <PanelCard>
        <PanelHeader>
          <Text variant="display-md">MCP</Text>
          <div style={{ marginTop: 2 }}>
            <Text variant="text-regular" color="var(--text-secondary)">
              This tenant is an MCP server. Add the URL as a remote MCP server
              in any client, signing in with OAuth or an API key. Service
              account keys can read, run, and build through chat, but not edit
              directly.{" "}
              <Link
                to={MCP_DOCS_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "inherit", textDecoration: "underline" }}
              >
                Learn more
              </Link>
            </Text>
          </div>
        </PanelHeader>
        <PanelContentBox>
          <Box gap={8}>
            <Text variant="text-small-md">Server URL</Text>
            <CopyableValue value={url}>
              <Text
                variant="text-regular"
                color="var(--text-secondary)"
                style={{ flex: 1 }}
              >
                {url}
              </Text>
            </CopyableValue>
          </Box>
        </PanelContentBox>
        <PanelContentBox>
          <Box gap={16}>
            <Box gap={8}>
              <Text variant="text-small-md">Claude Code</Text>
              <CodeBlock
                wrap
                content={`claude mcp add --transport http "3b" "${url}"`}
              />
            </Box>
            <Box gap={8}>
              <Text variant="text-small-md">Codex</Text>
              <CodeBlock wrap content={`[mcp_servers.3b]\nurl = "${url}"`} />
              <Text variant="text-small" color="var(--text-secondary)">
                Add to ~/.codex/config.toml
              </Text>
            </Box>
            <Box gap={8}>
              <Text variant="text-small-md">Cursor</Text>
              <CodeBlock
                wrap
                language="json"
                content={`{\n  "mcpServers": {\n    "3b": {\n      "url": "${url}"\n    }\n  }\n}`}
              />
              <Text variant="text-small" color="var(--text-secondary)">
                Add to ~/.cursor/mcp.json
              </Text>
            </Box>
          </Box>
        </PanelContentBox>
      </PanelCard>
    </PanelShell>
  );
}
